import orderBy from "lodash/orderBy";

import { ArticleSeriesGrid } from "@/components/pieces/learn/ArticleSeriesGrid";
import { useArticleSeriesByArticleQuery } from "@/graphql";
import { ArticleSeries } from "@/types/articles";
import { ensureNonNullArray } from "@/utils/array";

interface RelatedArticlesListProps {
  articleSlug: string;
  hasVisualSpace?: boolean;
  primarySeries?: ArticleSeries;
}

export function RelatedArticlesList({
  articleSlug,
  hasVisualSpace = false,
  primarySeries,
}: RelatedArticlesListProps) {
  const { data } = useArticleSeriesByArticleQuery({
    variables: {
      articleSlug,
    },
  });

  if (!data) {
    return null;
  }

  let articleSeriesList = ensureNonNullArray(data.articleSeriesByArticle);
  const primarySeriesSlug = primarySeries?.urlSlug;
  const existingPrimarySeries = articleSeriesList.find(
    ({ urlSlug }) => urlSlug === primarySeriesSlug,
  );

  if (primarySeriesSlug && existingPrimarySeries) {
    articleSeriesList = orderBy(
      articleSeriesList,
      ({ urlSlug }) => urlSlug === primarySeriesSlug,
      "desc",
    );
  }
  return (
    <div className={hasVisualSpace ? "mt-20" : ""}>
      {articleSeriesList.map((series, i) => (
        <div key={series.id} className="w-full">
          {i === 0 && <div className="border-t border-gray-200 w-full mb-16" />}
          <ArticleSeriesGrid
            seriesId={series.id}
            seriesSlug={series.urlSlug || ""}
            title={series.title || ""}
            totalCount={series.articleCount || 0}
            showLink={true}
            cardsPerPage={4}
          />
        </div>
      ))}
    </div>
  );
}
